// extracted by mini-css-extract-plugin
module.exports = {"base":"Details_base__252IB"};